import { z } from 'zod';

// FIXME: this list should be updated with the actual list of document types
// const VALID_DOCUMENT_TYPES_GENERAL = ['academicTranscript', 'passport', 'visa', 'bankStatement', 'other'];
// const VALID_DOCUMENT_TYPES_APPLICANT = [...VALID_DOCUMENT_TYPES_GENERAL];
// const VALID_DOCUMENT_TYPES_STUDENT = [...VALID_DOCUMENT_TYPES_GENERAL];
// const VALID_DOCUMENT_TYPES_UNI = [...VALID_DOCUMENT_TYPES_GENERAL];

const VALID_EXTENSIONS_GENERAL = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp'];
const VALID_EXTENSIONS_APPLICANT = [...VALID_EXTENSIONS_GENERAL];
// const VALID_EXTENSIONS_STUDENT = [...VALID_EXTENSIONS_GENERAL, 'csv'];
// const VALID_EXTENSIONS_UNI = [...VALID_EXTENSIONS_GENERAL, 'csv'];

const VALID_TYPES_GENERAL = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
const VALID_TYPES_APPLICANT = [...VALID_TYPES_GENERAL];
// const VALID_TYPES_STUDENT = [...VALID_TYPES_GENERAL, 'text/csv', 'application/csv'];
// const VALID_TYPES_UNI = [...VALID_TYPES_GENERAL, 'text/csv', 'application/csv'];

export const ApplicantDocUploadRequestSchema = z.object({
  docType: z.string(),
  // .refine(value => VALID_DOCUMENT_TYPES_APPLICANT.includes(value), {
  //   message: `Unsupported document type!`
  // })
  // .optional()
  // .nullable(),
  fileName: z.string().refine(value => VALID_EXTENSIONS_APPLICANT.some(ext => value.endsWith(`.${ext}`)), {
    message: `Unsupported file type!`
  }),
  fileType: z.string().refine(value => VALID_TYPES_APPLICANT.includes(value), {
    message: `Unsupported file type!`
  }),
  docKey: z.string(),
  studyId: z.string().optional()
});

// export const StudentDocUploadRequestSchema = z.object({
//   docType: z
//     .string()
//     // .refine(value => VALID_DOCUMENT_TYPES_STUDENT.includes(value), {
//     //   message: `Unsupported document type!`
//     // })
//     .optional()
//     .nullable(),
//   fileName: z.string().refine(value => VALID_EXTENSIONS_STUDENT.some(ext => value.endsWith(`.${ext}`)), {
//     message: `Unsupported file type!`
//   }),
//   fileType: z.string().refine(value => VALID_TYPES_STUDENT.includes(value), {
//     message: `Unsupported file type!`
//   }),

//   university: z.string().optional().nullable(),
//   id: z.string().optional().nullable(),
//   sponsorType: z.string().optional().nullable(),
//   sponsorKey: z.string().optional().nullable(),
//   docKey: z.string().optional().nullable(),
//   interviewType: z.string().optional().nullable(),
//   eventType: z.string().optional().nullable(),
//   eventKey: z.string().optional().nullable(),
//   interviewHash: z.string().optional().nullable(),
//   attemptHash: z.string().optional().nullable()
// });

// export const UniDocUploadRequestSchema = z.object({
//   docType: z.string(),
//   // .refine(value => VALID_DOCUMENT_TYPES_UNI.includes(value), {
//   //   message: `Unsupported document type!`
//   // }),
//   fileName: z.string().refine(value => VALID_EXTENSIONS_UNI.some(ext => value.endsWith(`.${ext}`)), {
//     message: `Unsupported file type!`
//   }),
//   fileType: z.string().refine(value => VALID_TYPES_UNI.includes(value), {
//     message: `Unsupported file type!`
//   }),

//   university: z.string().optional().nullable(),
//   id: z.string(),
//   sponsorType: z.string().optional().nullable(),
//   sponsorKey: z.string().optional().nullable(),
//   docKey: z.string().optional().nullable(),
//   interviewType: z.string().optional().nullable(),
//   eventType: z.string().optional().nullable(),
//   eventKey: z.string().optional().nullable(),
//   interviewHash: z.string().optional().nullable(),
//   attemptHash: z.string().optional().nullable()
// });

/* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
export interface ApplicantDocUploadRequest extends z.infer<typeof ApplicantDocUploadRequestSchema> {}
// export interface StudentDocUploadRequest extends z.infer<typeof StudentDocUploadRequestSchema> {}
// export interface UniDocUploadRequest extends z.infer<typeof UniDocUploadRequestSchema> {}
